import React from "react";
import ReactDOM from "react-dom";
import { logError, addContextLog } from "../../infrastructure/log";
import HexModal from "../../app/components/modals/HexModal";
import { showErrorMessage } from "../commons/show-error-message";
import { translate } from "../../infrastructure/translate/localization";
import ApproveRequestFinancial from "../../app/components/modals/requests/ApproveRequestFinancial";

function renderApproveRequestFinancialModal({ requestId, amount, fromFunds }) {
  const target = document.getElementById("table-request-education-container");

  if (target) {
    ReactDOM.render(
      <HexModal>
        <ApproveRequestFinancial
          requestId={requestId}
          amount={amount}
          fromFunds={fromFunds}
        />
      </HexModal>,
      document.getElementById("modal-container")
    );
  }
}

export async function displayApproveFinancialRequest({
  requestId,
  amount,
  fromFunds,
}) {
  try {
    renderApproveRequestFinancialModal({ requestId, amount, fromFunds });
    addContextLog("info", "displayApproveFinancialRequest", "display-screen", {
      requestId,
      amount,
    });
  } catch (e) {
    logError(
      e,
      `Error to displayApproveFinancialRequest in request ${requestId}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
